import moment from 'moment'

export default {
  data () {
    return {
      moment: moment
    }
  },
  methods: {
    _min (min, format) {
      if ([undefined, null, ''].includes(min)) return undefined
      if (format === 'number') return parseFloat(min)
      let $ = this // eslint-disable-line no-unused-vars
      try {
        return eval('`' + min + '`') // eslint-disable-line no-eval
      } catch (e) {
        return ''
      }
    },
    _max (max, format) {
      if ([undefined, null, ''].includes(max)) return undefined
      if (format === 'number') return parseFloat(max)
      let $ = this // eslint-disable-line no-unused-vars
      try {
        return eval('`' + max + '`') // eslint-disable-line no-eval
      } catch (e) {
        return ''
      }
    },
    _rules (rules) {
      let $ = this // eslint-disable-line no-unused-vars
      // let row = rows ? rows[index] : null
      if (typeof rules === 'string') return eval(rules) // eslint-disable-line no-eval
      return rules
    }
  }
}
